import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import React from "react";
import Modal from "react-bootstrap/Modal";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import ChangeLicensePlateViewModel from "viewModels/callCenter/search/charges/changeLicensePlateViewModel";
import ChangeLicensePlatePreviewView from "./changeLicensePlatePreviewView";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Button from "@edaz/edazkit/Button/index";
import ChangeLicensePlateFormView from "./changeLicensePlateFormView";

const ChangeLicensePlateView: ViewComponent<ChangeLicensePlateViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  const renderFirstStep = (
    <>
      <ChangeLicensePlateFormView vm={vm} />
      <ButtonToolbar className="justify-content-center">
        <Button style={{ minWidth: "13.5rem" }} type="reset" onClick={vm.onClose} variant="light">
          {vm.translateGeneral("cancel")}
        </Button>
        <Button style={{ minWidth: "13.5rem" }} type="submit" onClick={vm.onContinue}>
          {vm.translateGeneral("continue")}
        </Button>
      </ButtonToolbar>
    </>
  );

  const renderSecondStep = (
    <>
      <ChangeLicensePlatePreviewView vm={vm} />
      <ButtonToolbar className="justify-content-center">
        <Button style={{ minWidth: "13.5rem" }} type="reset" onClick={vm.onBack} variant="light">
          {vm.translateGeneral("back")}
        </Button>
        <Button style={{ minWidth: "13.5rem" }} disabled={!vm.changePreview?.canBeSubmitted} type="submit" onClick={vm.onSave}>
          {vm.translateGeneral("confirm")}
        </Button>
      </ButtonToolbar>
    </>
  );
  return (
    <Modal show={true} dialogClassName="modal-md" centered onHide={vm.onClose}>
      <Modal.Header closeButton={true}>
        <Modal.Title>{vm.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          {vm.changeStep === 1 && renderFirstStep}
          {vm.changeStep === 2 && renderSecondStep}
        </LoaderOverlay>
      </Modal.Body>
    </Modal>
  );
});

registerView(ChangeLicensePlateView, ChangeLicensePlateViewModel);
